import { call, put, takeLatest } from "redux-saga/effects";
import { httpCreateQuestionImage } from "../../../services/questions";
import {
  createQuestionImageStart,
  createQuestionImageSuccess,
  createQuestionImageFailure,
  createQuestionStart,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* handleCreateImage({ payload }) {
  const { data, callback } = payload;
  let imageFile = data?.imageUrl;
  const response = yield call(httpCreateQuestionImage, imageFile);
  const { success, raw, message } = response;

  if (success) {
    yield put(createQuestionImageSuccess());
    let modData = { ...data, imageUrl: raw?.id };
    yield put(createQuestionStart({ data: modData, callback }));
  } else {
    yield put(createQuestionImageFailure());
    networkErrorHandler(response.statusCode, message || raw?.error);
  }
}

export default function* onCreateQuestionImage() {
  yield takeLatest(createQuestionImageStart.type, handleCreateImage);
}
